export default __webpack_public_path__ + "ocr166ae0.png";